module.exports = __webpack_public_path__ + "img/pd-img36.4a79d957.jpg";